import { render, staticRenderFns } from "./PersonDetails.vue?vue&type=template&id=82a7f3fa&scoped=true&"
import script from "./PersonDetails.vue?vue&type=script&lang=ts&"
export * from "./PersonDetails.vue?vue&type=script&lang=ts&"
import style0 from "./PersonDetails.vue?vue&type=style&index=0&id=82a7f3fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a7f3fa",
  null
  
)

export default component.exports